/** @enum number */
const Modulos = Object.freeze({
  /** @type {0} */ GLOBAL: 0,
  /** @type {1} */ INTEGRACION_OCR: 1,
  /** @type {2} */ INTEGRACION_ERP: 2,
  /** @type {3} */ AUTO_FACTURA: 3,
  /** @type {4} */ WEBHOOKS_EMITIDAS: 4,
  /** @type {5} */ WEBHOOKS_RECIBIDAS: 5,
  /** @type {6} */ APROBACION_FACTURAS: 6,
  /** @type {7} */ GENERACION_FACTURAS_PDF: 7,
  /** @type {8} */ TICKETBAI_BATUZ: 8,
  /** @type {9} */ INTEGRACION_AAD: 9,
  /** @type {10} */ INTERFAZ_EMISION: 10,
  /** @type {11} */ EMISION_FACTURAS: 11,
  /** @type {12} */ RECEPCION_FACTURAS: 12,
  /** @type {15} */ AGRUPACIONES: 15,
  /** @type {16} */ CUENTA_CORREO_ZC: 16,
  /** @type {17} */ CUENTA_CORREO_CLIENTE: 17,
  /** @type {18} */ CORREOS_AVISOS_PERSONALIZADOS: 18,
  /** @type {19} */ LOGO_PERSONALIZADO: 19,
  /** @type {22} */ COLORES_PERSONALIZADOS: 22,
  /** @type {30} */ INTEGRACION_SAML2: 30,
  /** @type {31} */ VERIFACTU: 31,
  /** @type {32} */ FACTURAS_RECURRENTES: 32,
  /** @type {33} */ INFORMES: 33,
  /** @type {34} */ IMPORTACIONES: 34,
})
export default Modulos
